/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CustomizedHydroOutputVariablesEnum } from "./CustomizedHydroOutputVariablesEnum";
import {
  CustomizedHydroOutputVariablesEnumFromJSON,
  CustomizedHydroOutputVariablesEnumFromJSONTyped,
  CustomizedHydroOutputVariablesEnumToJSON,
  CustomizedHydroOutputVariablesEnumToJSONTyped,
} from "./CustomizedHydroOutputVariablesEnum";
import type { OutputPrecisionEnum } from "./OutputPrecisionEnum";
import {
  OutputPrecisionEnumFromJSON,
  OutputPrecisionEnumFromJSONTyped,
  OutputPrecisionEnumToJSON,
  OutputPrecisionEnumToJSONTyped,
} from "./OutputPrecisionEnum";

/**
 *
 * @export
 * @interface OutputSettings
 */
export interface OutputSettings {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly simulationId?: number;
  /**
   * Create domain wide results file.
   */
  createHydroResults?: boolean;
  /**
   * Create structure control results file.
   */
  createStructureControlResults?: boolean;
  /**
   * Output time step in seconds.
   */
  hydroOutputTimeStep?: number | null;
  /**
   * Output start time in seconds.
   */
  hydroOutputStartTime?: number;
  /**
   * Output end time in seconds.
   */
  hydroOutputEndTime?: number;
  /**
   * Single or double precision output.
   *
   * * `1` - single
   * * `2` - double
   */
  hydroOutputPrecision?: OutputPrecisionEnum;
  /**
   * Single or double precision output for aggregation results.
   *
   * * `1` - single
   * * `2` - double
   */
  aggregationOutputPrecision?: OutputPrecisionEnum;
  /**
   * Customized hydro output time step in seconds.
   */
  customizedHydroOutputTimeStep?: number | null;
  /**
   * Customized hydro output start time in seconds.
   */
  customizedHydroOutputStartTime?: number;
  /**
   * Customized hydro output end time in seconds.
   */
  customizedHydroOutputEndTime?: number;
  /**
   * Single or double precision output for customized hydro results.
   *
   * * `1` - single
   * * `2` - double
   */
  customizedHydroOutputPrecision?: OutputPrecisionEnum;
  /**
   * The output variables for the customized results area.
   */
  customizedHydroOutputVariables?: Array<CustomizedHydroOutputVariablesEnum>;
  /**
   * Create debug hydro results file.
   */
  createDebugHydroResults?: boolean;
}

/**
 * Check if a given object implements the OutputSettings interface.
 */
export function instanceOfOutputSettings(value: object): value is OutputSettings {
  return true;
}

export function OutputSettingsFromJSON(json: any): OutputSettings {
  return OutputSettingsFromJSONTyped(json, false);
}

export function OutputSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OutputSettings {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    simulationId: json["simulation_id"] == null ? undefined : json["simulation_id"],
    createHydroResults:
      json["create_hydro_results"] == null ? undefined : json["create_hydro_results"],
    createStructureControlResults:
      json["create_structure_control_results"] == null
        ? undefined
        : json["create_structure_control_results"],
    hydroOutputTimeStep:
      json["hydro_output_time_step"] === undefined
        ? undefined
        : json["hydro_output_time_step"] === null
        ? null
        : json["hydro_output_time_step"],
    hydroOutputStartTime:
      json["hydro_output_start_time"] == null ? undefined : json["hydro_output_start_time"],
    hydroOutputEndTime:
      json["hydro_output_end_time"] == null ? undefined : json["hydro_output_end_time"],
    hydroOutputPrecision:
      json["hydro_output_precision"] == null
        ? undefined
        : OutputPrecisionEnumFromJSON(json["hydro_output_precision"]),
    aggregationOutputPrecision:
      json["aggregation_output_precision"] == null
        ? undefined
        : OutputPrecisionEnumFromJSON(json["aggregation_output_precision"]),
    customizedHydroOutputTimeStep:
      json["customized_hydro_output_time_step"] === undefined
        ? undefined
        : json["customized_hydro_output_time_step"] === null
        ? null
        : json["customized_hydro_output_time_step"],
    customizedHydroOutputStartTime:
      json["customized_hydro_output_start_time"] == null
        ? undefined
        : json["customized_hydro_output_start_time"],
    customizedHydroOutputEndTime:
      json["customized_hydro_output_end_time"] == null
        ? undefined
        : json["customized_hydro_output_end_time"],
    customizedHydroOutputPrecision:
      json["customized_hydro_output_precision"] == null
        ? undefined
        : OutputPrecisionEnumFromJSON(json["customized_hydro_output_precision"]),
    customizedHydroOutputVariables:
      json["customized_hydro_output_variables"] == null
        ? undefined
        : (json["customized_hydro_output_variables"] as Array<any>).map(
            CustomizedHydroOutputVariablesEnumFromJSON
          ),
    createDebugHydroResults:
      json["create_debug_hydro_results"] == null ? undefined : json["create_debug_hydro_results"],
  };
}

export function OutputSettingsToJSON(json: any): OutputSettings {
  return OutputSettingsToJSONTyped(json, false);
}

export function OutputSettingsToJSONTyped(
  value?: Omit<OutputSettings, "id" | "simulationId"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    create_hydro_results: value["createHydroResults"],
    create_structure_control_results: value["createStructureControlResults"],
    hydro_output_time_step: value["hydroOutputTimeStep"],
    hydro_output_start_time: value["hydroOutputStartTime"],
    hydro_output_end_time: value["hydroOutputEndTime"],
    hydro_output_precision: OutputPrecisionEnumToJSON(value["hydroOutputPrecision"]),
    aggregation_output_precision: OutputPrecisionEnumToJSON(value["aggregationOutputPrecision"]),
    customized_hydro_output_time_step: value["customizedHydroOutputTimeStep"],
    customized_hydro_output_start_time: value["customizedHydroOutputStartTime"],
    customized_hydro_output_end_time: value["customizedHydroOutputEndTime"],
    customized_hydro_output_precision: OutputPrecisionEnumToJSON(
      value["customizedHydroOutputPrecision"]
    ),
    customized_hydro_output_variables:
      value["customizedHydroOutputVariables"] == null
        ? undefined
        : (value["customizedHydroOutputVariables"] as Array<any>).map(
            CustomizedHydroOutputVariablesEnumToJSON
          ),
    create_debug_hydro_results: value["createDebugHydroResults"],
  };
}
